import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_FAQS_DATA, FETCH_FAQS_EDIT_DATA } from "./actionTypes";
import {
  fetchFaqsSuccess,
  fetchFaqsFailure,
  fetchFaqsEditSuccess,
  fetchFaqsEditFailure,
} from "./actions";

function* fetchFaqsDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/faqs",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchFaqsSuccess(response.data));
  } catch (error) {
    yield put(fetchFaqsFailure(error.message));
  }
}

function* fetchFaqsEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/faqs/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchFaqsEditSuccess(response.data));
  } catch (error) {
    yield put(fetchFaqsEditFailure(error.message));
  }
}

export default function* faqsSaga() {
  yield takeEvery(FETCH_FAQS_DATA, fetchFaqsDataSaga);
  yield takeEvery(FETCH_FAQS_EDIT_DATA, fetchFaqsEditDataSaga);
}
